import { formatNumber, roundDecimalNumberToInteger } from '@/utils';

const formattedTooltip = (coordinate) => {
  const getInteractionsTemplate = (interactions) => {
    if (!interactions) return '';

    return `
      <div class="highcharts-custom-tooltip__item">
        <span class="interactions">
          <div class="interactions__point" style="background: ${interactions.color};"></div>
          Interações
        </span> 
        <span class="highcharts-custom-tooltip__interations">${formatNumber(interactions.y)}</span>
      </div>
    `;
  };

  const getEngagementRateTemplate = (engagementRate) => {
    if (!engagementRate) return '';

    const engagementRateFormatted = roundDecimalNumberToInteger(engagementRate.y);

    return `
      <div class="highcharts-custom-tooltip__item">
        <span class="engagement">Índice de engajamento</span> 
        <span class="highcharts-custom-tooltip__engagement-rate">${formatNumber(engagementRateFormatted)}</span>
      </div>
    `;
  };

  const interactionsTemplate = getInteractionsTemplate(coordinate.points.find(element => element.series.options.id === 'interactions'));
  const engagementTemplate = getEngagementRateTemplate(coordinate.points.find(element => element.series.options.id === 'engagementRate'));

  return `
    <div class="highcharts-custom-tooltip">
      <div>
        <div class="highcharts-custom-tooltip__name">${coordinate.x}</div>
      </div>

      <div class="highcharts-custom-tooltip__content">
        
      ${interactionsTemplate}

      ${engagementTemplate}

      </div>
    </div>    
  `;
};

export default formattedTooltip;
